export const validate = (value) => {
  // info: https://stackoverflow.com/questions/12011792/regular-expression-matching-a-3-or-4-digit-cvv-of-a-credit-card

  const cvcRegExp = /^[0-9]{3,4}$/;

  return !!cvcRegExp.test(value);
};
